// @flow
import Sales from './Sales';
import { dataKey } from './dataKey';


export default Sales;
export { dataKey };
